const Definition = (props) => {
    let dd = props.dd;
    switch(dd) {
        case '':
        case null:
            return null
        case 0:
            dd = 'No'
            break
        case 1:
            dd = 'Yes'
            break
    }
    return (
        <>
            <dt className={'col-sm-4'}>
                {props.dt}
            </dt>
            <dd className={'col-sm-8'}>
                {dd}
            </dd>
        </>
    )
}

export default Definition
